import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { WINDOW } from '../services/window.service';

const LAST_RELOAD_KEY = 'wf-maintenance-reload';
const RELOAD_INTERVAL_MS = 60_000;

/**
 * While the site is closed for maintenance IIS answers API calls with 503. Reloading lets IIS show the maintenance
 * page instead of leaving an open app with failing calls.
 */
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  readonly #window = inject(WINDOW) as Window;

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(req).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === 503 && this.#mayReload()) {
          this.#window.location.reload();
        }
        return throwError(() => res);
      })
    );
  }

  // A 503 that is not the closed site would otherwise reload the app over and over
  #mayReload(): boolean {
    try {
      const lastReload = Number(this.#window.sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0);
      if (Date.now() - lastReload < RELOAD_INTERVAL_MS) return false;
      this.#window.sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
    } catch {
      // No session storage: reload anyway, the closed site does not load the app again
    }
    return true;
  }
}
